module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "frontmatter",
      "id": "ser"
    }
  }, [_c('p', {
    staticClass: "sert"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "ii",
      "id": "pii",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Chicago Studies in Ethnomusicology")]), _vm._v(" "), _c('p', {
    staticClass: "sered"
  }, [_c('i', [_vm._v("A series edited by Philip V. Bohlman and Timothy Rommen")])]), _vm._v(" "), _c('p', {
    staticClass: "serah"
  }, [_c('i', [_vm._v("Editorial Board")])]), _vm._v(" "), _c('p', {
    staticClass: "sered"
  }, [_vm._v("Margaret J. Kartomi")]), _vm._v(" "), _c('p', {
    staticClass: "sered"
  }, [_vm._v("Anthony Seeger")]), _vm._v(" "), _c('p', {
    staticClass: "sered"
  }, [_vm._v("Kay Kaufman Shelemay")]), _vm._v(" "), _c('p', {
    staticClass: "sered"
  }, [_vm._v("Martin H. Stokes")]), _vm._v(" "), _c('p', {
    staticClass: "sered"
  }, [_vm._v("Bonnie C. Wade")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f80924f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-lie-0003.vue
// module id = 60
// module chunks = 0